import { useEffect } from 'react';

export const useScrollToBottom = ({
  ref,
  hasNextPage,
  isFetching,
  fetchNextPage,
  threshold = 20
}: {
  ref: React.RefObject<HTMLElement>;
  hasNextPage: boolean;
  isFetching: boolean;
  fetchNextPage: () => void;
  threshold?: number;
}) => {
  useEffect(() => {
    const handleScroll = () => {
      if (!ref.current || !hasNextPage || isFetching) return;

      const { scrollTop, scrollHeight, clientHeight } = ref.current;
      if (scrollTop + clientHeight >= scrollHeight - threshold) {
        fetchNextPage();
      }
    };

    const element = ref.current;
    if (element) {
      element.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener('scroll', handleScroll);
      }
    };
  }, [ref, hasNextPage, isFetching, fetchNextPage, threshold]);
};